import classnames from 'classnames';
import React, { useEffect } from 'react';

import { useFocus } from '../../../hooks/useFocus';
import './layout.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  wide?: boolean;
  focusOnRender?: boolean;
}

const Layout: React.FC<Props> = ({ wide = false, focusOnRender = false, children, ...rest }) => {
  const { ref, setFocus } = useFocus();

  useEffect(() => {
    if (focusOnRender) {
      setFocus();
    }
  }, [focusOnRender, setFocus]);

  return (
    <main className="main-layout" ref={ref} {...rest}>
      <div className={classnames('container padded', { wide: wide })}>{children}</div>
    </main>
  );
};

export default Layout;
